import { t } from '@lingui/macro';

// Kept out of `utils/Asset/index.ts` so that reading or seeding the labels does
// not drag that module's dependencies (date-fns, lodash, utils/Appointments)
// along with it. The test setup seeds these labels for every test file, and
// through the barrel that cost ~0.2s of module evaluation per file.

let assetTypeLabelsByCode: Record<string, string> = {};

export function setAssetTypeLabels(
  labels: ReadonlyArray<{ code: string; label: string }>,
): void {
  assetTypeLabelsByCode = labels.reduce<Record<string, string>>(
    (acc, { code, label }) => {
      acc[code] = label;
      return acc;
    },
    {},
  );
}

export default function assetTypeText(id: Maybe<string>): string {
  if (id == null || id === '') return t`Unknown`;

  return assetTypeLabelsByCode[id] ?? t`Unknown`;
}
